import React, { Fragment, useContext, useEffect, useState, memo } from "react";
import CanvasJSReact from '../../../../modules/env/canvasjs.react';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const interfaceDateFormat = 'yyyyMMdd';

export default memo((props) => {

    const {graphParam, mealType} = props;

    let rangeMaxBs = 200;
    let rangeMinBs = 0;

    let bfMaxBs = graphParam.stripLines.bfMaxBs;
    let bfMinBs = graphParam.stripLines.bfMinBs;
    let afMaxBs = graphParam.stripLines.afMaxBs;
    let afMinBs = graphParam.stripLines.afMinBs;

    if(mealType === "A") {
        bfMaxBs = 0;
        bfMinBs = 0;
    }

    if(mealType === "B") {
        afMaxBs = 0;
        afMinBs = 0;
    }
    
    graphParam.dataPointList.map((m,i) => {
        if(i == 0) {
            // rangeMaxBs = m.y;
            // rangeMinBs = m.y;

            rangeMaxBs = graphParam.stripLines.afMaxBs;
            rangeMinBs = graphParam.stripLines.bfMinBs;
        }

        if(m.y > rangeMaxBs) {
            rangeMaxBs = m.y;
        }

        if(m.y < rangeMinBs) {
            rangeMinBs = m.y;
        }
    });

    if(rangeMaxBs > 0) {
        rangeMaxBs = rangeMaxBs + 40;
    }

    if(rangeMinBs > 40) {
        rangeMinBs = rangeMinBs - 40;
    }

    let options = {
        zoomEnabled: true,
        height: 300,
        toolTip:{
            shared: true,
            contentFormatter: function (e) {
				var content = " ";
					content += e.entries[0].dataPoint.label;
					content += "<br/>";
					content += "<font color='#61d1bc'>";

                    if(e.entries[0].dataPoint.markerType == "circle") {
                        content += "식전";
                    } else {
                        content += "식후";
                    }

                    content +=  e.entries[0].dataSeries.name;
                    content +=  ":</font>" + " " + "<strong>" + e.entries[0].dataPoint.y + "</strong>"
				
                    return content;
			}
        },
        axisX: {
            labelAngle: 0,
        },
        axisY: {
            labelAutoFit: false,
            gridDashType: "dash",
            interval: 20,
            minimum: rangeMinBs,
            maximum: rangeMaxBs,
            stripLines: [
                {
                    startValue: bfMinBs,
                    endValue: bfMaxBs,
                    color: "yellow",
                    opacity: .2
                },
                {
                    startValue: afMinBs,
                    endValue: afMaxBs,
                    color: "#bfebda",
                    opacity: .2
                }
            ]
        },
        data: [
            { 
                type: "line",
                name: "혈당",
                markerSize: 7,
                markerColor: "#73c8b8",
                showInLegend: false,
                lineColor: "#bbbbbb",
                dataPoints: graphParam.dataPointList
            }
        ]
    }

    return(
        <div style={{marginTop:"7vw"}}>
			<CanvasJSChart options = {options} 
				/* onRef={ref => this.chart = ref} */
			/>
		</div>
    );
})